export default "__VITE_ASSET__yyFP7jKK__"